import React from "react";
import { Box } from "@mui/material";

/**
 * FleetFixedColumn - Renders a fixed Y-axis column with labels (for fleet charts)
 * @param {string} position - Position of the column: "left" or "right"
 * @param {string} label - Axis label text
 * @param {Array} labelData - Array of { value, position } objects for Y-axis labels
 * @param {number} chartHeight - Height of the chart (default: 315px)
 * @param {number} width - Width of the column (default: 60px)
 */
const FleetFixedColumn = ({
    position = "left",
    label,
    labelData = [],
    chartHeight = 315,
    width = 60
}) => {
    const isLeft = position === "left";

    return (
        <Box
            sx={{
                width: `${width}px`,
                flexShrink: 0,
                zIndex: 10,
                backgroundColor: "white",
                paddingTop: "0px",
                paddingBottom: "0",
                display: "flex",
                gap: "2px",
                flexDirection: isLeft ? "row" : "row-reverse",
            }}
        >
            {/* Axis Label */}
            <Box
                sx={{
                    fontSize: "12px",
                    color: "#686868",
                    fontWeight: 400,
                    writingMode: "vertical-rl",
                    transform: isLeft ? "rotate(180deg)" : "rotate(0deg)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20px",
                }}
            >
                {label}
            </Box>

            {/* Y-axis Labels */}
            <Box
                sx={{
                    height: `${chartHeight}px`,
                    position: "relative",
                    flex: 1,
                }}
            >
                {labelData.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            fontSize: "12px",
                            color: "#686868",
                            textAlign: isLeft ? "right" : "left",
                            paddingRight: isLeft ? "8px" : "0px",
                            paddingLeft: isLeft ? "0px" : "8px",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            position: "absolute",
                            top: `${item.position}px`,
                            [isLeft ? "right" : "left"]: 0,
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: isLeft ? "flex-end" : "flex-start",
                        }}
                    >
                        {item.value}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default FleetFixedColumn;
